import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
const bonuses = [{
  title: 'Diagnóstico Express: ¿Es mío o lo absorbí?',
  description: 'Guía práctica para distinguir lo que te pertenece de lo que absorbiste.',
  image: 'https://cdn.magicpatterns.com/uploads/3LUna6SngJ7hksL7fRhe5D/bono_1.png',
  alt: 'Mockup del Diagnóstico Express en tablet y libro'
}, {
  title: 'Audio "Botón de Reinicio" (7 min)',
  description: 'Audio breve para recuperar tu eje después de momentos intensos.',
  image: 'https://cdn.magicpatterns.com/uploads/rL9QD87xP39zh2H9uwniia/bono_2.png',
  alt: 'Mockup del audio Botón de Reinicio en celular'
}, {
  title: 'Guía de Límites Energéticos Cotidianos',
  description: 'Herramientas concretas para dejar de absorber sin cerrarte.',
  image: 'https://cdn.magicpatterns.com/uploads/ftrhTwS1KUFV2LD4651h6G/bono_3.png',
  alt: 'Mockup de la Guía de Límites Energéticos en tablet y libro'
}, {
  title: 'Ritual Diario de 5 Minutos',
  description: 'Práctica simple para empezar el día centrada.',
  image: 'https://cdn.magicpatterns.com/uploads/mS8wZ44C9z55bcEhmi4ytY/bono_4.png',
  alt: 'Mockup del Ritual Diario en celular'
}, {
  title: 'Cierre Energético Semanal',
  description: 'Proceso guiado para evitar acumulación emocional.',
  image: 'https://cdn.magicpatterns.com/uploads/52XC9dU2KxXHbrE8xavrVk/bono_5.png',
  alt: 'Mockup del Cierre Energético Semanal en tablet'
}];
export function BonusesSection() {
  return <SectionWrapper bgColor="sand" data-id="element-1">
      <div className="text-center mb-16" data-id="element-2">
        <span className="text-[10px] font-medium tracking-[0.3em] uppercase text-plum/70 mb-4 block" data-id="element-3">
          INCLUIDO EN EL MÉTODO PRO MIND ENERGY™
        </span>
        <span className="text-xs font-medium tracking-[0.2em] uppercase text-text-secondary mb-3 block" data-id="element-4">
          Edición limitada
        </span>
        <h2 className="text-3xl md:text-4xl text-text" data-id="element-5">
          Bonos exclusivos por lanzamiento
        </h2>
      </div>

      {/* 2-column grid for first 4 bonuses */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-6">
        {bonuses.slice(0, 4).map((bonus, index) => <div key={index} className="bg-ivory border border-border-custom shadow-[0_1px_3px_rgba(0,0,0,0.04)] overflow-hidden" data-id="element-7">
            <div className="aspect-[4/3] w-full overflow-hidden bg-sand" data-id="element-8">
              <img src={bonus.image} alt={bonus.alt} className="w-full h-full object-cover" data-id="element-9" />
            </div>
            <div className="p-6 md:p-8" data-id="element-10">
              <span className="text-xs font-medium tracking-[0.15em] uppercase text-plum mb-3 block" data-id="element-11">
                Bono {index + 1}
              </span>
              <h3 className="text-xl md:text-2xl text-text mb-3 leading-snug" data-id="element-12">
                {bonus.title}
              </h3>
              <p className="text-text-secondary leading-relaxed" data-id="element-13">
                {bonus.description}
              </p>
            </div>
          </div>)}
      </div>

      {/* Bonus 5 — now with image */}
      <div className="max-w-lg mx-auto" data-id="element-14">
        <div className="bg-ivory border border-border-custom shadow-[0_1px_3px_rgba(0,0,0,0.04)] overflow-hidden" data-id="element-15">
          <div className="aspect-[4/3] w-full overflow-hidden bg-sand" data-id="element-16">
            <img src={bonuses[4].image!} alt={bonuses[4].alt} className="w-full h-full object-cover" data-id="element-17" />
          </div>
          <div className="p-6 md:p-8 text-center" data-id="element-18">
            <span className="text-xs font-medium tracking-[0.15em] uppercase text-plum mb-3 block" data-id="element-19">
              Bono 5
            </span>
            <h3 className="text-xl md:text-2xl text-text mb-3 leading-snug" data-id="element-20">
              {bonuses[4].title}
            </h3>
            <p className="text-text-secondary leading-relaxed" data-id="element-21">
              {bonuses[4].description}
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}